export const TERMINAL_TYPES = [
  'Ocean Ports',
  'Equipment Depots',
  'Railroad Terminals',
  'Customs Container Station',
  'Bonded Warehouse',
  'Inspection Facility',
  'Customs Admin Site',
  'Exam Site',
].map(i => i.toUpperCase());